import React from 'react';

import { Box, Typography } from '@mui/material';

import type { ScreenshotFallbackProperties } from './ScreenshotFallback.types';

export const ScreenshotFallback: React.FC<ScreenshotFallbackProperties> = ({
  fallbackColor,
  urlNormalised = '',
  url = '',
  dataTest = 'screenshot_fallback',
}) => (
  <Box
    data-testid={dataTest}
    sx={{
      height: 160,
      backgroundColor: fallbackColor,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Typography
      color='white'
      sx={{
        fontSize: '24px',
        fontWeight: 700,
        letterSpacing: '0.05em',
        opacity: 0.9
      }}>
      {urlNormalised || url}
    </Typography>
  </Box>
);
